
const baseComponents = require.context('./base', true, /\.coffee$/)
baseComponents.keys().forEach(baseComponents)

const commomComponents = require.context('./common', true, /\.coffee$/)
commomComponents.keys().forEach(commomComponents)